module.exports = __webpack_public_path__ + "img/xunlianying.2c83b8af.svg";